import {
  RESET_REDUX,
  RECEIVE_PARTICIPANT_STUDIES,
  SET_SELECTED_PARTICIPANT_ID,
  RESET_PARTICIPANT_STUDIES,
  REQUEST_PARTICIPANT_STUDIES,
  REQUEST_LOCAL_PARTICIPANTS_LIST,
  RECEIVE_LOCAL_PARTICIPANTS_LIST,
  RESET_LOCAL_PARTICIPANTS_LIST,
  REQUEST_REMOTE_PARTICIPANTS_LIST,
  RECEIVE_REMOTE_PARTICIPANTS_LIST,
  RESET_REMOTE_PARTICIPANTS_LIST,
  REQUEST_LOCAL_PARTICIPANT_LOG,
  RECEIVE_LOCAL_PARTICIPANT_LOG,
  REQUEST_REMOTE_PARTICIPANT_LOG,
  RECEIVE_REMOTE_PARTICIPANT_LOG,
  RESET_LOCAL_PARTICIPANT_LOG,
  RESET_REMOTE_PARTICIPANT_LOG,
  ADD_STUDY_TO_REDUX,
} from "../actions/index";
import produce from "immer";
import { studyFixture } from "../constants/Fixtures/studyFixture";
const initialState = {
  // Participant Log
  logParticipantsById: {},
  logParticipantsByProtocolId: {},
  logParticipantAllIds: [],
  localParticipantLogFetching: false,
  localParticipantLogRecevied: true,
  remoteParticipantLogFetching: false,
  remoteParticipantLogRecevied: true,

  // Participant List
  localParticipantsById: {
    [studyFixture.study.studyInfo.participantId]: {
      studyById: {
        [studyFixture.study.studyInfo.id]: { ...studyFixture.study.studyInfo },
      },
      participantInfo: { ...studyFixture.study.studyInfo },
    },
  },
  localParticipantAllIds: [],

  remoteParticipantsById: {},
  remoteParticipantAllIds: [],

  localParticipantsListFetching: false,
  localParticipantsListRecevied: true,
  remoteParticipantsListFetching: false,
  remoteParticipantsListReceived: true,

  // availableParticipantsReceived: false,
  // setParticipantStudiesFetching: false,

  setParticipantStudiesFetching: false,
  setParticipantStudiesReceived: true,

  selectedParticipantId: null,
  reviewStudies: {},
  reviewSavePath: null,
};

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ADD_STUDY_TO_REDUX: {
        console.log(action);
        if (
          Object.keys(draft.localParticipantsById).includes(
            action.study.study.studyInfo.participantId
          )
        ) {
          draft.localParticipantsById[
            action.study.study.studyInfo.participantId
          ] = {
            studyById: {
              ...draft.localParticipantsById[
                action.study.study.studyInfo.participantId
              ].studyById,
              [action.study.study.studyInfo.id]: {
                ...action.study.study.studyInfo,
              },
            },
            participantInfo: { ...action.study.study.studyInfo },
          };
        } else {
          draft.localParticipantsById[
            action.study.study.studyInfo.participantId
          ] = {
            studyById: {
              [action.study.study.studyInfo.id]: {
                ...action.study.study.studyInfo,
              },
            },
            participantInfo: { ...action.study.study.studyInfo },
          };
        }

        break;
      }
      case REQUEST_LOCAL_PARTICIPANT_LOG: {
        draft.localParticipantLogFetching = true;
        break;
      }
      case RECEIVE_LOCAL_PARTICIPANT_LOG: {
        draft.localParticipantLogFetching = false;
        draft.localParticipantLogRecevied = true;
        draft.logParticipantsByProtocolId =
          action.participantLog.participantsByProtocolId;
        draft.logParticipantAllIds = action.participantLog.allParticipantIds;

        draft.logParticipantsById = action.participantLog.participantsById;
        break;
      }

      case RESET_LOCAL_PARTICIPANT_LOG: {
        draft.localParticipantLogFetching = false;
        draft.localParticipantLogRecevied = true;
        break;
      }

      case REQUEST_REMOTE_PARTICIPANT_LOG: {
        draft.remoteParticipantLogFetching = true;
        draft.remoteParticipantLogRecevied = false;
        break;
      }

      case RECEIVE_REMOTE_PARTICIPANT_LOG: {
        draft.remoteParticipantLogFetching = false;
        draft.remoteParticipantLogRecevied = true;
        draft.logParticipantsByProtocolId =
          action.participantLog.participantsByProtocolId;
        draft.logParticipantAllIds = action.participantLog.allParticipantIds;
        draft.logParticipantsById = action.participantLog.participantsById;
        break;
      }

      case RESET_REMOTE_PARTICIPANT_LOG: {
        draft.remoteParticipantLogFetching = false;
        break;
      }

      case REQUEST_LOCAL_PARTICIPANTS_LIST: {
        draft.localParticipantsListFetching = true;
        draft.localParticipantsListRecevied = false;
        break;
      }
      case RECEIVE_LOCAL_PARTICIPANTS_LIST: {
        draft.localParticipantAllIds = Object.keys(action.allParticipants);
        draft.localParticipantsById = action.allParticipants;
        draft.localParticipantsListFetching = false;
        draft.localParticipantsListRecevied = true;
        break;
      }
      case RESET_LOCAL_PARTICIPANTS_LIST: {
        draft.localParticipantAllIds = [];
        draft.localParticipantsById = {};
        draft.localParticipantsListFetching = false;
        draft.localParticipantsListRecevied = false;
        break;
      }
      case REQUEST_REMOTE_PARTICIPANTS_LIST: {
        draft.remoteParticipantsListFetching = true;
        draft.remoteParticipantsListReceived = false;
        break;
      }
      case RECEIVE_REMOTE_PARTICIPANTS_LIST: {
        draft.remoteParticipantAllIds = Object.keys(action.allParticipants);
        draft.remoteParticipantsById = action.allParticipants;
        draft.remoteParticipantsListFetching = false;
        draft.remoteParticipantsListReceived = true;
        break;
      }
      case RESET_REMOTE_PARTICIPANTS_LIST: {
        draft.remoteParticipantAllIds = [];
        draft.remoteParticipantsById = {};
        draft.remoteParticipantsListFetching = false;
        draft.remoteParticipantsListReceived = false;
        break;
      }

      case REQUEST_PARTICIPANT_STUDIES: {
        draft.setParticipantStudiesFetching = true;
        draft.setParticipantStudiesReceived = false;
        break;
      }

      case RECEIVE_PARTICIPANT_STUDIES: {
        draft.setParticipantStudiesFetching = false;
        draft.setParticipantStudiesReceived = true;
        draft.reviewStudies = action.studies;
        draft.reviewSavePath = action.savePath;
        break;
      }

      case RESET_PARTICIPANT_STUDIES: {
        draft.setParticipantStudiesFetching = false;
        draft.setParticipantStudiesReceived = false;
        break;
      }

      case SET_SELECTED_PARTICIPANT_ID: {
        draft.selectedParticipantId = action.participantId;
        break;
      }

      case RESET_REDUX:
        let renewState = {};
        renewState = {
          ...initialState,
          localParticipantsById: draft.localParticipantsById,
        };
        return renewState;
      default:
        return draft;
    }
  });
